/**
 * hover figure caption with mouse direction
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2016 MAAB
 * http://www.github.com/maab16/hover-figure-caption-with-mouse-direction
 *
 * Edited by Juan de la Oliva.
 */
 
 ;(function($,window,document,undefined){
    'use strict';

    var paddings = 45;

    if ($(window).width() <= 989) {
        var test = 15;
    } else {
        var test = 5;
    }
  
    var deafults = {

            containerWidth : 0,
            containerHeight : 0,
            nOfRow : 0,
            nOfColumn : 0,
            aspectRatio : '1:1',
            containerMargin : '50px auto 0',
            itemWidth : 0,
            itemHeight : 0,
            itemDistance : 20,
            animationSpeed : 200,
            containerAnimationDelay : 100,
            allContainerAnimationSpeed : 300,
            easing                      : 'swing',
            margin : 0,
            responsive : [
               {
                    breakpoint : 1600,
                    containerWidth : 1560,
                    settings : {
                        nOfRow : 2,
                        nOfColumn : 4
                    }
                },
               {
                    breakpoint : 1400,
                    containerWidth : 1360,
                    settings : {
                        nOfRow : 2,
                        nOfColumn : 4
                    }
                },
                {
                    breakpoint : 1200,
                    containerWidth : 1160,
                    settings : {
                        nOfRow : 3,
                        nOfColumn : 3
                    }
                },
                {
                    breakpoint : 989,
                    containerWidth : 949,
                    settings : {
                        nOfRow : 3,
                        nOfColumn : 3
                    }
                },
                {
                    breakpoint : 768,
                    containerWidth : 738,
                    settings : {
                        nOfRow : 2,
                        nOfColumn : 2
                    }
                }
            ]

    }

    function filterData(element,options){
        return;
        this.settings   = $.extend({},deafults,options);
        this.element    = $(element);
        this.win        = $(window).innerWidth();
        this.containerWidth1 = this.win + test;
        this.all        = this.element.find('>div');
        this.totalItems      = this.all.length;
        //this.containerWidth  = (this.settings.containerWidth == 0) ? this.element.width() : this.settings.containerWidth;
        //this.nOfColumn       = (this.settings.nOfColumn == 0) ? Math.round(this.containerWidth/this.all.width()) : this.settings.nOfColumn;
        //this.nOfRows         = (this.settings.nOfRow == 0) ? Math.ceil(this.totalItems/this.nOfColumn) : this.settings.nOfRow;
        var self = this;


        $(window).on('resize',function(){
            self.win = $(this).width();
            self.setScreen(self.win, self.totalItems);
            self.recalculateItemwith($(this).width())
        });

        this.init();

    };

    filterData.prototype = {

        init : function(){
                var self = this;
                if (self.win >= 1600) {
                    self.setSettings(1600);
                }else if (self.win >= 1400) {
                    self.setSettings(1400);
                }else if (self.win >= 1200) {
                    self.setSettings(1200);
                }else if (self.win >= 989) {
                    self.setSettings(989);
                }else if (self.win >= 768) {
                    self.setSettings(768);
                }else if (self.win < 768) {
                    self.setSettings('xtra-small');
                }

                //if (self.win <= 989) {
                //    paddings = 15;
                // } else {
                //    paddings = 45;
                // }

                if (self.win <= 989) {
                    test = 15;
                } else {
                    test = 5;
                }
          
                self.containerWidth = self.containerWidth1;


                self.itemWidth       = (self.settings.itemWidth == 0) ? self.containerWidth/self.nOfColumn : self.settings.itemWidth;
                self.itemHeight         = self.getHeightFromRatio();       
                self.containerHeight = (self.settings.containerHeight == 0) ?  self.getContainerHeight() : self.settings.containerHeight;
                self.top = 0,
                self.j=0,
                self.k=0;
          
          
                //Style Container
                self.element.css({
                    width : self.containerWidth,
                    height : self.containerHeight,
                    position : 'relative',
                    overflow : 'hidden',
                    //marginLeft: '-'+paddings+'px',

                });
                //Style Each Item
                self.all.each(function(i,item){
                    if (self.j*self.itemWidth >= self.element.width()) {
                        self.j = 0;
                        self.k++;
                    }
                    $(this).css({
                        width : self.itemWidth,
                        //height : self.itemHeight,
                        position : 'absolute',
                        left : (self.j*self.itemWidth),
                        top  : self.k*self.itemHeight,
                        paddingTop : self.settings.itemDistance
                        //padding : '20px 0 20px '+paddings+'px',
                    });
                    //$(this).find('> .product-card').css({
                    //    padding: 0,
                    //});
                    self.j++;
                });
                // Style Figure
                self.all.find('figure').css({
                    width : '100%',
                    height : '100%'
                });
                //Style Images
                self.all.find('img').css({
                    width : '100%',
                    height : '100%'
                });
                $('a[href^="#"] , button').on('click', function(event) {
                    self.$item = $(this).data('filter');
                    if (undefined !== self.$item) {
                        $(this).addClass('active-filter');
                        self.items = self.element.find('div'+self.$item);
                        self.totalItems = self.items.length;
                        self.m=0;
                        self.n=0;
                    }      
                    if ($(this).hasClass('active-filter')) {
                        self.controllDisplay();
                    }
                    if(self.$item != "all" && self.totalItems == 0){
                      self.element[0].previousElementSibling.style.display = "none";
                    }else {
                    self.element[0].previousElementSibling.style.display = "block";
                    }
                });
        },
        controllDisplay : function(){

            switch(this.$item){
                case 'all':
                    this.displayAll();
                    break;
                default :
                    this.displaySingleCategory();
                    break;
            }
        },
        setScreen : function(containerWidth2, itemsNumber){
            var self = this;
            if (self.win >= 1600) {
                    self.setSettings(1600);
                }else if (self.win >= 1400) {
                    self.setSettings(1400);
                }else if (self.win >= 1200) {
                    self.setSettings(1200);
            }else if (self.win >= 989) {
                self.setSettings(989);
            }else if (self.win >= 768) {
                self.setSettings(768);
            }else if (self.win < 768) {
                self.setSettings('xtra-small');
            }

            //if (self.win <= 989) {
            //    paddings = 15;
            // }else {
            //    paddings = 45;
            // }

            if (self.win <= 989) {
                test = 15;
            } else {
                test = 5;
            }
          
            self.containerWidth = containerWidth2 + test;

          
            //console.log('win : '+self.win);
            //console.log('container : '+self.containerWidth);
            //console.log('container : '+self.nOfColumn);
            self.settings.animationSpeed = 0;
            self.settings.containerAnimationDelay = 0;
            self.settings.allContainerAnimationSpeed = 0;
            //self.nOfRows         = (self.settings.nOfRow == 0) ? Math.ceil(self.totalItems/self.nOfColumn) : self.settings.nOfRow;
            self.itemWidth       = (self.settings.itemWidth == 0) ? self.containerWidth/self.nOfColumn : self.settings.itemWidth;
            self.itemHeight         = self.getHeightFromRatio();
            self.top = 0,
            self.j=0,
            self.k=0;
            self.containerHeight = (self.settings.containerHeight == 0) ?  self.getContainerHeight(itemsNumber) : self.settings.containerHeight;
            
            //Style Container
            self.element.css({
                width : self.containerWidth,
                height : self.containerHeight,
                position : 'relative',
                overflow : 'hidden',
                //marginLeft: '-'+paddings+'px',
            });

            self.button = $('body').find('button');
            self.button.each(function(){
            });   
        },
        setSettings : function(breakpoint){
            var self = this;
            $.each(self.settings.responsive,function(index,responsive){
                if (responsive.breakpoint == breakpoint){
                    self.nOfColumn  = responsive.settings.nOfColumn;
                    self.nOfRows = responsive.settings.nOfRow;
                    self.containerWidth = responsive.containerWidth;
                }
            });
            if (breakpoint == 'xtra-small') {
                self.containerWidth = self.win;
                self.nOfColumn  = 1;
                self.nOfRows = 3;
            }
        },
        getRgba : function(hex,alpha=1) {
            var r,g,b,a=alpha,
                //match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/),
                match = hex.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i),
                hex = (match !== null) ? match[1] : '000';
                //console.log(hex);

            if (hex.length == 6) {
                r = parseInt(hex.substring(0, 2), 16);
                g = parseInt(hex.substring(2, 4), 16);
                b = parseInt(hex.substring(4, 6), 16);
            }else if (hex.length == 3) {
                r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
                g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
                b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
            }
            return r+','+g+','+b+','+a;
        },
        getHeightFromRatio : function(){
            this.ratio = this.settings.aspectRatio.split(':');
            return Math.ceil((this.itemWidth*this.ratio[1])/this.ratio[0]);
        },
        getContainerHeight : function(numItems){
          if (numItems) {
            this.nItems = numItems;
          } else {
            this.nItems = this.totalItems;
          }
           return ((Math.ceil(this.nItems / this.nOfColumn)) * this.itemHeight);
        },
     
      recalculateItemwith : function(){
            var self = this;
            self.j=0,
            self.k=0;
            self.all.each(function(i,item){

              if(item.style.opacity !== '0'){
                            
                            if (self.j*self.itemWidth >= self.element.width()) {
                    self.j = 0;
                    self.k++;
                }
                $(this).css({
                    width : self.itemWidth,
                    height : self.itemHeight,
                    position : 'absolute',
                    left : (self.j*self.itemWidth),
                    top  : self.k*self.itemHeight,
                    paddingTop : self.settings.itemDistance
                    //padding : '20px 0 20px '+paddings+'px',
                });
                self.j++;

              }
                
            });
         },
      
        displayAll : function(){
            var self = this;

            var newHeight = self.getContainerHeight(self.all.length);
            self.totalItems = self.all.length;


            // Display all
            self.all.css({
                display : 'block',
                opacity : 1,
                transform : 'scale(1)',
                //transition : 'all 0.5s ease'
            });
            // Animate all
            self.all.each(function(i,item){
                if (self.m*self.itemWidth >= self.element.width()) {
                    self.m = 0;
                    self.n++;
                }
                $(this).css({
                    display : 'block',
                    opacity : 1,
                    width : self.itemWidth,
                    height : self.itemHeight,
                    position : 'absolute',
                }).animate({
                    left : (self.m*self.itemWidth),
                    top  : self.n*self.itemHeight
                },
                self.settings.animationSpeed,
                self.settings.easing);
                self.m++;
            });

            self.element
            .delay(self.settings.containerAnimationDelay)
            .animate({
               height : newHeight
               //height : self.getContainerHeight(self.all.length)
            },self.settings.allContainerAnimationSpeed);
        },
        displaySingleCategory : function(){
            var self = this,
                Rows = Math.ceil(self.totalItems/self.nOfColumn),
                containerHeight;
                if (Rows <= self.nOfRows) {
                    containerHeight = self.itemHeight*Rows;
                }else{
                    containerHeight = self.getContainerHeight();
                }
            if (self.$item != undefined) {
                // Hide all if not match current items
                self.all.each(function(i,item){
                    if (!self.matchCurrent(item)) {
                        $(this).css({
                            display : 'block',
                            opacity : 0,
                            transform : 'scale(0)',
                            //transition : 'all 0.5s ease'
                        });
                    }
                });
                // Show all element if matches current items
                self.items.css({
                        display : 'block',
                        opacity : 1,
                        transform : 'scale(1)',
                       // transition : 'all 0.5s ease',
                    });
                // Animate all items
                $(self.items).each(function(i,item){
                    if (self.m*self.itemWidth >= self.element.width()) {
                        self.m = 0;
                        self.n++;
                    }
                    $(item).css({
                        display : 'block',
                        opacity : 1,
                        width : self.itemWidth,
                        height : self.itemHeight,
                        position : 'absolute',
                    });
                    $(this).animate({
                        left : self.m*self.itemWidth,
                        top  : self.n*self.itemHeight
                    },
                    self.settings.animationSpeed,
                    self.settings.easing);
                    self.m++;
                });
                self.element.delay(self.settings.containerAnimationDelay)
                .animate({
                    height : containerHeight
                },self.settings.allContainerAnimationSpeed);
            }
        },
        matchCurrent : function(current){
            var currentItems = $.map(self.items, function(value, index) {
                    return [value];
                });
            for (var i = 0; i < currentItems.length; i++) {
                if (current === currentItems[i]) {
                    return true;
                }
            }
            return false;
        }
    };

    $.fn.filterData = function(options){

        return this.each(function(){

            if (!$.data(this,'filterData')) {

                $.data(this,'filterData',new filterData(this,options));
            }
        });
    };


})(jQuery,window,document);